module.exports = __webpack_public_path__ + "img/why-bg.b40a7d19.svg";